export default [
  {
    title: "Dashboard",
    route: "dashboard",
    icon: "HomeIcon",
  },  
 
  {
    title: "Instant Estimate",
    icon: "FileIcon",
    route: 'instant-estimation',
  },
  {
    title: "Quotation",// edit the content of tis page !!!!!!***************************************
    route: "",
    icon: "FileTextIcon",
    children: [
      {
        title: "Quotation lists",
        route: "sale-quotation",
      },
      {
        title: "Add Quotation",
        route: "add-sale-quotation",
      },
    ]
  },
  {
    title: "Booking",
    icon: "CalendarIcon",
    route: 'booking',
  },
  // {
  //   title: "Booking",
  //   route: "",
  //   icon: "CheckIcon",
  //   children: [
  //     {
  //       title: "Booking lists",
  //       route: "booking",
  //     },
  //     {
  //       title: "Booking settings",
  //       route: "booking-quotation",
  //     },
  //   ]
  // },
  {
    title: "B/L",
    icon: "FileTextIcon",
    route: 'bl',

  },
  
  {
    title: "Data management",
    icon: "DatabaseIcon",
    children: [
      {
        title: "User",
        route: "",
        icon: "UserIcon",
        children: [
          {
            title: "Clients",
            route: 'customers',//add Customer route***************************************************************
          },
          {
            title: "Agent",
            route: 'agents',//add Agent route***************************************************************
          },
          //add Admin route***************************************************************
          // {
          //   title: "Admin",
          //   route: 'admins',
          // },
          
        ],
      },
      {
        title: "Containers data",
        route: "data-management",
      },
      {
        title: "Commodity / classe / un  data",
        route: "commodity-data-management",
      },
      {
        title: "Vessel data",
        route: "vessel-data-management",
      },
      {
        title: "Voyage data",
        route: "voyage-data-management",
      },
      {
        title: "Port data",
        route: "agency-data-management",
      },
      {
        title: "Other data (Test)",
        route: "other-data-management",
      },
    ]
  },
  {
    title: "Guide Line",
    route: "",
    icon: "MapIcon",
    children: [
      {
        title: "Add guide Line",
        route: "guide-line-quotation",
      },
      {
        title: "Guide Line List",
        route: "guide-line-list",
      },
    ]
  },
  // {
  //   title: "Schedule",
  //   icon: "ClockIcon",
  //   route: 'schedule',

  // },
  {
    title: "Contact",
    icon: "MailIcon",
    route: "contact",
  },
  {
    title: "Settings",
    icon: "SettingsIcon",
    route: "settings",
  },
];
